import React from "react";
import { ArrowUpRight, Map } from "lucide-react";
import useReveal from "../../hooks/useReveal";

/** LA County bike map (Marina del Rey & region) — opens in a new browser tab. */
export const MARINA_BIKE_MAP_PDF =
  "https://file.lacounty.gov/SDSInter/dbh/docs/189949_2013-BIKEMAP85x11Web-Ready(highres).pdf";

const IMG_MARINA_PATH = "/ebikes-beach.png";

export const MarinaMapDownload = () => {
  const ref = useReveal();
  return (
    <section
      id="marina-map"
      ref={ref}
      data-testid="marina-map-section"
      className="relative bg-[#FAFAFA] px-6 sm:px-8 py-28 sm:py-40 border-t border-[#E5E5E5]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <p className="reveal text-xs uppercase tracking-[0.3em] text-[#6F6F6F] mb-6">
            Marina del Rey
          </p>
          <h2
            className="reveal reveal-delay-1 font-display text-black"
            style={{
              fontSize: "clamp(2.25rem, 5vw, 4.25rem)",
              lineHeight: 1.02,
              letterSpacing: "-1.4px",
            }}
          >
            Plan your ride with the{" "}
            <span className="italic text-[#6F6F6F]">official bike map.</span>
          </h2>
          <p className="reveal reveal-delay-2 mt-8 text-base sm:text-lg text-[#6F6F6F] leading-relaxed max-w-md">
            LA County publishes a printable 8.5×11 bike map covering Marina del
            Rey, the Ballona paths, and connections toward Venice and Santa
            Monica. Save it to your phone or open the high-resolution PDF
            before you head out.
          </p>
          <a
            href={MARINA_BIKE_MAP_PDF}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="marina-map-pdf-link"
            className="reveal reveal-delay-3 mt-10 inline-flex items-center gap-3 btn-pill px-8 py-4 text-base group"
          >
            <Map size={20} strokeWidth={1.5} aria-hidden />
            Open bike map (PDF)
            <ArrowUpRight
              size={18}
              strokeWidth={1.25}
              className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              aria-hidden
            />
          </a>
          <p className="reveal reveal-delay-3 mt-4 text-sm text-[#6F6F6F]">
            Opens in a new tab · Source: Los Angeles County
          </p>
        </div>

        <div className="lg:col-span-7 reveal reveal-delay-2">
          <a
            href={MARINA_BIKE_MAP_PDF}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative block overflow-hidden rounded-2xl border border-[#E5E5E5] bg-white shadow-sm aspect-[4/3] sm:aspect-[16/10]"
          >
            <img
              src={IMG_MARINA_PATH}
              alt="Paradise Worldwide e-bikes on the beach at golden hour"
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8">
              <p className="text-xs uppercase tracking-[0.25em] text-white/80">
                County bike map
              </p>
              <p className="mt-2 font-display text-2xl sm:text-3xl text-white">
                High-res PDF · print or pinch-zoom on your device
              </p>
              <span className="mt-4 inline-flex items-center gap-2 text-sm text-white/90">
                View PDF
                <ArrowUpRight size={16} strokeWidth={1.5} />
              </span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default MarinaMapDownload;
